module.exports = __webpack_public_path__ + "static/img/znsy_p3.9876598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsy_p3.png
// module id = OqJx
// module chunks = 19